import { render, staticRenderFns } from "./dynamicRecord.vue?vue&type=template&id=6c48ab31&scoped=true"
import script from "./dynamicRecord.vue?vue&type=script&lang=js"
export * from "./dynamicRecord.vue?vue&type=script&lang=js"
import style0 from "./dynamicRecord.vue?vue&type=style&index=0&id=6c48ab31&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c48ab31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c48ab31')) {
      api.createRecord('6c48ab31', component.options)
    } else {
      api.reload('6c48ab31', component.options)
    }
    module.hot.accept("./dynamicRecord.vue?vue&type=template&id=6c48ab31&scoped=true", function () {
      api.rerender('6c48ab31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/components/dynamicRecord.vue"
export default component.exports